import React from 'react';
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import UrgentCareZipCode from './UrgentCareZipCode';
import Spinner from "../common/spinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class MyLocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showZipForm: false, UserLocation: '' };
        this.setCityZip = this.setCityZip.bind(this);
        this.setLocation = this.setLocation.bind(this);
    }

    componentDidMount() {
        const { userAddresses, fetchingUserAddress, getGeoLocation } = this.props;
        if (fetchingUserAddress === false && (userAddresses === null || (userAddresses && userAddresses.length === 0))) {//Task 34261
            this.setState({ showZipForm: true });
        }
        else {
            this.setLocation();
        }
        logUI("MBHWeb.UI.MyLocation.ComponentDidMount", new Date(), Tools.getURLPath());
    }


    componentDidUpdate(prevProps, nextState) {
        if (!this.state.showZipForm) {
            const { fetchingLatLong, userLocation, geolocationError, userAddressToLatLngFailure } = this.props;

            ////if (prevProps.fetchingLatLong === true && fetchingLatLong === false && userLocation) {
            ////    const { lat, lng } = userLocation;
            ////    if (lat && lng) {
            ////        // Got lat/lng from API                
            ////        this.setCityZip(`${lat},${lng}`);
            ////        this.redirectToFindCare(`${lat},${lng}`);
            ////    }
            ////}
            ////else
            if ((geolocationError !== undefined && geolocationError !== "" && geolocationError !== prevProps.geolocationError) || userAddressToLatLngFailure) {//Task 34261
                this.setState({ showZipForm: true });
            }
            else if (geolocationError === "") {
                const { latitude, longitude } = this.props;
                if (latitude && longitude) {
                    this.setCityZip(`${latitude},${longitude}`);
                    this.redirectToFindCare(`${latitude},${longitude}`);
                } else {
                    this.setState({ showZipForm: true });
                }
            }
        }
    }

    redirectToFindCare(location) {
        // Redirects to Find Care with location
        const userlocation = location ? `&location=${location}` : "";
        this.props.history.push({
            pathname: '/findcare',
            searchParms: `?isUrgentCare=true${userlocation}`
        });
    }

    getContactAddress() {
        const { userAddresses } = this.props;
        return userAddresses && userAddresses.length > 0 ? userAddresses.find(address => {
            return address.AddressType && address.AddressType === "contact";
        }) : null;
    }

    setLocation() {
        const { userAddresses, userLocation, getLatLongFromAddress, fetchingUserAddress } = this.props;

        if (fetchingUserAddress === false && userAddresses && userAddresses.length > 0) {
            const userAddress = this.getContactAddress();
            if (userAddress) {
                // const addressFormat = this.computedAddressFormat(userAddress);
                // getLatLongFromAddress(addressFormat);
                if (userAddress.ZipCode) {
                    let zipCode = userAddress.ZipCode.split('-')[0];
                    this.setCityZip(zipCode);
                    this.redirectToFindCare(zipCode);
                } else {
                    this.setState({ showZipForm: true });
                }

            } else {
                this.setState({ showZipForm: true });
            }
            //else if (userAddress && userLocation) {
            //    const { lat, lng } = userLocation;
            //    if (lat && lng) {
            //        // Got lat/lng from API                   
            //        this.setCityZip(`${lat},${lng}`);
            //        this.redirectToFindCare(`${lat},${lng}`);
            //    }
            //}
        } else {
            this.setState({ showZipForm: true });
        }
    }

    setCityZip(value) {
        this.setState({ UserLocation: value });
    }

    computedAddressFormat(userAddress) {
        const { AddressLine1, AddressLine2, City, State, ZipCode } = userAddress;
        let addressFormat = "";
        if (AddressLine1) {
            addressFormat += `${AddressLine1},`;
        }
        if (AddressLine2)
            addressFormat += `${AddressLine2},`;
        if (City) {
            addressFormat += `${City},`;
        }
        if (State)
            addressFormat += `${State}-`;
        if (ZipCode)
            addressFormat += `${ZipCode},`;
        addressFormat = addressFormat.slice(0, -1);
        return addressFormat;
    }
    render() {
        const { fetchingLatLong, fetchingUserAddress, isFromVideoVisitPage } = this.props;
        return (
           this.state.showZipForm ?
                <>
                    <div className="row">
                        <div className="col-12">
                            <h1 className="step-heading">Where do you need to find care?</h1>
                        </div>
                    </div>
                    <UrgentCareZipCode
                        getGeoLocation={this.props.getGeoLocation}
                        currentLat={this.props.latitude}
                        currentLong={this.props.longitude}
                        cityZip={this.state.UserLocation}
                        setCityZip={this.setCityZip}
                        history={this.props.history}
                        geoLocationError={this.props.geolocationError}
                        isFromVideoVisitPage={isFromVideoVisitPage}
                    />
                </> :
                fetchingLatLong || fetchingUserAddress ? <Spinner /> : null
        );
    }
}

const mapStateToProps = (state) => {
    return {
        latitude: state.locations.latitude,
        longitude: state.locations.longitude,
        fetchingLatLong: state.healthSource.fetchingLatLong,
        fetchingUserAddress: state.healthSource.fetchingUserAddress,
        userLocation: state.healthSource.userLocation,
        geolocationError: state.locations.geolocationError,
        userAddressToLatLngFailure: state.healthSource.isFetchingUserAddressToLatLngFailure
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getLatLongFromAddress: (address) => dispatch({ type: types.GET_LAT_LNG_USER_ADDRESS_START, address }),
        getGeoLocation: (useCurrentLocation) => dispatch({ type: types.GEOLOCATION, useCurrentLocation: useCurrentLocation })
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(MyLocation);